export const CSRF_TOKEN_ID = 'anti-csrftoken-a2z';
